/** Converts a hex color to rbg format. Works for both 3 digit and 6 digit hex. */
function hexToRgb(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) {
        // Default to black if unable to match
        return { r: 0, g: 0, b: 0 };
    }
    return {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
    };
}
/**
 * Determines wether an rgb color is predominantly dark.
 * This algorithm is W3C standard: https://www.w3.org/TR/AERT/#color-contrast
 */
function isDarkRGB(color) {
    return (color.r * 299 + color.g * 587 + color.b * 114) / 1000 < 128;
}
/**
 * Determines wether a hex color is predominantly dark.
 * This algorithm is W3C standard: https://www.w3.org/TR/AERT/#color-contrast
 */
function isDarkHex(hex) {
    var rgb = hexToRgb(hex);
    return isDarkRGB(rgb);
}

export { hexToRgb, isDarkHex, isDarkRGB };
